var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import 'rc-dropdown/assets/index.css';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { Icon } from '@material-ui/core';
import { prefixExReact } from '../../../helpers/components';
import { setLocale } from '../../../store/actions/locale';
import { localeSelector } from '../../../store/selectors/locale';
var DefaultLabel = styled.div.attrs(function () { return ({
    className: prefixExReact('intl-switcher-label'),
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n\n  > span:first-child {\n    margin-right: 4px;\n  }\n"], ["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n\n  > span:first-child {\n    margin-right: 4px;\n  }\n"])));
var StyledMenu = styled(Menu).attrs(function () { return ({
    className: prefixExReact('intl-switcher-menu'),
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var StyledMenuItem = styled(MenuItem).attrs(function () { return ({
    className: prefixExReact('intl-switcher-menu-item'),
}); })(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var getLocaleMenu = function (locales, handleLocaleClick) { return (React.createElement(StyledMenu, null, locales.map(function (locale) { return (React.createElement(StyledMenuItem, { key: locale.key, onClick: function () { return handleLocaleClick(locale.key); } }, locale.label)); }))); };
var IntlSwitcher = function (props) {
    var locales = props.locales, Label = props.labelComponent, dropdownProps = props.dropdownProps, restProps = __rest(props, ["locales", "labelComponent", "dropdownProps"]);
    var locale = useSelector(localeSelector());
    var dispatch = useDispatch();
    var currentLocale = locales.find(function (loc) { return loc.key === locale.lang; });
    var handleLocaleClick = function (key) {
        i18next.changeLanguage(key);
        dispatch(setLocale(key, {}));
    };
    return (React.createElement(Dropdown, __assign({ overlay: getLocaleMenu(locales.filter(function (loc) { return loc.key !== currentLocale.key; }), handleLocaleClick), trigger: ['click'] }, dropdownProps),
        React.createElement(Label, __assign({}, restProps),
            React.createElement("span", null, currentLocale && currentLocale.label),
            "\u00A0",
            React.createElement(Icon, null, "keyboard_arrow_down"))));
};
IntlSwitcher.propTypes = {
    locales: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string,
        label: PropTypes.string,
    })),
    labelComponent: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.elementType,
    ]),
    dropdownProps: PropTypes.object,
};
IntlSwitcher.defaultProps = {
    locales: [
        {
            key: 'en-US',
            label: 'English',
        },
        {
            key: 'es-ES',
            label: 'Español',
        },
    ],
    labelComponent: DefaultLabel,
    dropdownProps: {},
};
export default IntlSwitcher;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map